var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortUpDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.18119 0.87969C3.46003 0.600858 3.9137 0.600858 4.19253 0.87969L7.04941 3.73657C7.25396 3.94227 7.31453 4.24738 7.20368 4.51593C7.09169 4.78333 6.83229 4.95703 6.54203 4.95703H0.828266C0.540293 4.95703 0.279745 4.78333 0.167755 4.51593C0.0569081 4.24738 0.118617 3.94227 0.322027 3.73657L3.17891 0.87969H3.18119Z",
    fill: "#C8C8C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18137 10.4628L0.324485 7.60587C0.11879 7.40017 0.0593665 7.09506 0.170213 6.82651C0.282203 6.55911 0.540465 6.38541 0.830725 6.38541H6.5422C6.83018 6.38541 7.09187 6.55911 7.20386 6.82651C7.3147 7.09506 7.25299 7.40017 7.04958 7.60587L4.1927 10.4628C3.91387 10.7416 3.4602 10.7416 3.18137 10.4628Z",
    fill: "#C8C8C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUpDownArrow);
export default __webpack_public_path__ + "static/media/sort_up_down_arrow.2c8361198b78c73e4f862f84847a5c42.svg";
export { ForwardRef as ReactComponent };